export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5641.3b02d1f5.jpg";